// Types
import { FeatureFlagType } from 'types/FeatureFlag.types';

// Config
import featureConstants from '@constants/featureConstants';

export function getDisableFeatureOverrideFromCookie() {
  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith('feature_override_cookie='))
    ?.split('=')[1];

  if (!cookieValue) return undefined;

  const disableFeatureEntry = cookieValue
    .split('&')
    .find((feature) => feature.startsWith(`${featureConstants.DISABLE_FEATURE}:`));

  if (!disableFeatureEntry) return undefined;

  const [, enabled, ...variantParts] = disableFeatureEntry.split(':');
  const variant = variantParts.join(':');

  return {
    enabled: enabled === 'true',
    variant: variant || undefined,
  };
}

export const restoreDisableFeatureOverride = (features: FeatureFlagType[]) => {
  const disableFeatureOverride = getDisableFeatureOverrideFromCookie();

  if (!disableFeatureOverride?.variant) return features;

  return features.map((feature) =>
    feature.id === featureConstants.DISABLE_FEATURE ? { ...feature, ...disableFeatureOverride } : feature,
  );
};

const unionWithDevFeatures = (bffFeatures: FeatureFlagType[]): FeatureFlagType[] => {
  const localFeatures: FeatureFlagType[] = window.env.FEATURES || [];

  const updatedLocalFeatures = localFeatures.map((localFeature) => {
    const bffFeature = bffFeatures.find((feature) => feature.id === localFeature.id && feature.impressionId);
    return bffFeature ? { ...localFeature, impressionId: bffFeature.impressionId } : localFeature;
  });

  const features = Array.from(
    new Map([...bffFeatures, ...updatedLocalFeatures].map((feature) => [feature.id, feature])).values(),
  );

  return restoreDisableFeatureOverride(features);
};

export default unionWithDevFeatures;
